import { _elements } from './_elements';
import { _updateNavigatorButtons } from './_updateNavigatorButtons';

/**
 * This function is used to fade to a certain item in the slider.
 * In most cases this will be used to fade to the next/previous item.
 */
export const _fade = ( slider, index = 0 ) => {

	const {
		items,
		navigator,
	} = _elements( slider );

	// const reversedItems = [ ...items ].reverse();

	let cards = document.querySelectorAll(".c-testimonials-card");
	let cards_intro = document.querySelectorAll(".s-testimonials__item-intro")

	items.forEach( ( item, i ) => {
		if ( i === index ) {
			setTimeout( () => {
				item.classList.add( 'is-active' );
				slider.style.height = `${ cards[i].scrollHeight + cards_intro[i].scrollHeight + 150 }px`;
				// item.classList.add( 'has-animation' );
			}, 300 );
		} else {
			item.classList.remove( 'is-active' );
		}
	} );

	_updateNavigatorButtons( navigator, index );
	slider.setAttribute( 'data-slider-current', index );
};

